import React from "react";
import { Button, Td, Text, Tr } from "@chakra-ui/react";

function TablesAdvertiserRow(props) {
  const { user, address, phone_number, lastItem } = props;

  const handleSelectChange = (event) => {
    console.log("Selected value:", event.target.value);
  };
  return (
    <Tr>
      <Td
        minWidth={{ sm: "150px" }}
        ps='0px'
        border={lastItem ? "none" : null}
        borderBottomColor='#56577A'
      >
        <Text
          fontSize='sm'
          color='#fff'
          fontWeight='normal'
          minWidth='100%'
          align='center'
        >
          {user?.username || "N/A"}
        </Text>
      </Td>

      <Td
        minWidth={{ sm: "200px" }}
        ps='0px'
        border={lastItem ? "none" : null}
        borderBottomColor='#56577A'
      >
        <Text
          fontSize='sm'
          color='#fff'
          fontWeight='normal'
          minWidth='100%'
          align='center'
        >
          {user?.email || "N/A"}
        </Text>
      </Td>

      <Td
        minWidth={{ sm: "200px" }}
        border={lastItem ? "none" : null}
        borderBottomColor='#56577A'
      >
        <Text
          fontSize='sm'
          color='#fff'
          fontWeight='normal'
          minWidth='100%'
          align='center'
        >
          {address ? address : "N/A"}
        </Text>
      </Td>
      <Td border={lastItem ? "none" : null} borderBottomColor='#56577A'>
        <Text
          fontSize='sm'
          color='#fff'
          fontWeight='normal'
          minWidth='100%'
          align='center'
        >
          {phone_number ? phone_number : "N/A"}
        </Text>
      </Td>

      {/* <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Button
          p="2px 10px"
          bg="transparent"
          borderRadius="8px"
          border="1px solid #fff"
          variant="no-hover"
        >
          <Text
            fontSize="sm"
            color="gray.400"
            fontWeight="bold"
            cursor="pointer"
          >
            View
          </Text>
        </Button>
      </Td> */}
    </Tr>
  );
}

export default TablesAdvertiserRow;
